// export const baseURL = "https://cosmos.bajajfinservsecurities.in/api/rm";
export const baseURL = "https://cosmos.bajajfinservsecurities.in/api/rm";
export const esopBaseURL = "https://cosmos.bajajfinservsecurities.in";
export const Samadhan_Base_Url =
  "https://samadhanapi.bajajfinservsecurities.in/api";
// export const Msil_Base_Url =
//   "https://uat-ws.bajajfinservsecurities.in/msil-bfsl-services";
export const hniBaseUrl = "https://cosmos.bajajfinservsecurities.in/api/rm/hni";
export const pledgeBaseUrl = "https://api.bajajfinservsecurities.in/api/dp";
export const GenerateLinkURL = "https://hniekyc.bajajfinservsecurities.in";
export const MutualFundsProdURL = "https://mf.bajajbroking.in/api";

export const DASHBOARD_DEFAULT = {
  ClientStatus_URL: baseURL + "/Default/ClientStatus", //
  BuisnessSnapshot_URL: baseURL + "/Default/v2/BusinessSnapshotNew", //
  MTFSnapshot_URL: baseURL + "/Default/MTFBookDashborad",
  MTFBookDetails_URL: baseURL + "/Default/MTFBookDashboradDetail",
  RevenueSnapshot_URL: baseURL + "/Default/V2/RevenueSnapshot", //
  AUMSnapshot_URL: baseURL + "/Default/V2/AUMSnapshot", //
  SaleSnapshot_URL: baseURL + "/Default/TurnoverSnapshot", //
  ClientSnapshot_URL: baseURL + "/Default/ClientSnapshot", //
  GetBirthdayList_URL: baseURL + "/Default/Birthday", //
  SendBirthdayWishEmail_URL: baseURL + "/Default/BirthdaySendWishEmail", //
  TopActiveClient_URL: baseURL + "/Default/TopActiveClients", //
  TopInActiveClient_URL: baseURL + "/Default/TopInActiveClients", //
  DefaultRanking_URL: baseURL + "/Default/DefaultRanking", //
  NewDefaultRanking_URL: baseURL + "/Default/DefaultRankingNew", //
  SummaryReactivation_URL: baseURL + "/Default/SummaryReactivation", //
  SummaryReactivationDetail_URL: baseURL + "/Default/SummaryReactivationDetail", //
  RevenueSnapshotEquityModel_URL:
    baseURL + "/Default/RevenueSnapshotEquityDetails", //
  RevenueSnapshotFnoModel_URL: baseURL + "/Default/RevenueSnapshotFNODetails", //
  AUMSnapshotEquityModel_URL: baseURL + "/Default/v2/AUMSnapshotDetails", //
  RevenueSnapshotMTFModel_URL: baseURL + "/Default/DefaultMtfDetails", //
  CuspaReportDetails: baseURL + "/Report/CuspaReportDetails",
  AgeingReportDetails: baseURL + "/Report/AgeingReportDetails",
  MtfShortFallReportDetails: baseURL + "/Report/MtfShortFallReportDetails",
  ThirtyDaysAgeingDetails: baseURL + "/Report/ThirtyDaysAgeingDetails",
  RevenueSnapshotDetails:baseURL+"/Default/v2/RevenueSnapshotDetails",
  AumMFDetails: baseURL + "/Default/AUMSnapshotClientDetails"
};

export const DASHBOARD_EQUITY = {
  //   ClientStatus_URL: baseURL + "/Default/ClientStatus",
  IpoDetails_URL: baseURL + "/Equity/IpoDetails", //
  EquityClientStatusGraph_URL: baseURL + "/Equity/EquityClientStatus", //
  StockSegmentation_URL: baseURL + "/Equity/StockSegmentation", //
  BrokerageSummary_URL: baseURL + "/Equity/BrokerageSummary", //
  TodayClientInfo_URL: baseURL + "/Equity/TodayClientInfo", //
  TopActiveClient_URL: baseURL + "/Equity/TopActiveClients", //
  TopInActiveClient_URL: baseURL + "/Equity/TopInActiveClients", //
  EquityRanking_URL: baseURL + "/Equity/EquityRanking", //
  NewEquityRanking_URL: baseURL + "/Equity/EquityRankingNew", //
  NakedDebit_URL: baseURL + "/Equity/NakedDebit_ClientInfo", //
  QuaterlySettlement_URL: baseURL + "/Equity/quarterlysettlement",
};
//
export const DASHBOARD_CLIENT_OVERVIEW = {
  BasicDetails_URL: baseURL + "/Default/v2/BasicDetails", //
  PortfolioAnalysis_URL: baseURL + "/Equity/PortfolioAnalysis", //
  NetWorth_URL: baseURL + "/Equity/NetWorth", //
  PortfolioOverYear_URL: baseURL + "/Equity/PortfolioOverYear", //
  GetAllDocuments_URL: baseURL + "/Default/GetAllDocuments", //
  DownloadAllDocuments_URL: baseURL + "/Default/DownloadDocument", //
  IpoInfo_URL: baseURL + "/Default/IpoInfo", //
  ClientSummary_URL: baseURL + "/Equity/ClientSummary", //
  SummaryClient_URL: baseURL + "/Equity/ClientSummaryDetail", //
  ClientBrokerage_URL: baseURL + "/Default/ClientBrokerage", //
};

export const DASHBOARD_CLIENT_DETAIL_EQUITY = {
  InvestmentSnapshot_URL: baseURL + "/Equity/InvestmentSnapshot?clientCode=", //
  TradingTransactions_URL: baseURL + "/Equity/TradingTransactionsPage", //
  // Holdings_URL: baseURL + "/Equity/Holdings", //
  Holdings_URL: baseURL + "/Report/holding",
  Position_URL: baseURL + "/Report/Positions",
  Stock_Analytics_URL: baseURL + "/Client/StockAnalytics", //
  Stock_Analytics_New_URL: baseURL + "/Default/StockAnalyticsNew", //
  DividendInfo_URL: baseURL + "/default/Dividend", //
  MarginDetail_URL: baseURL + "/default/MarginDetails", //
  PayinPayout_URL: baseURL + "/default/PayinPayoutDetails", //
  PortfolioGrowth_URL: baseURL + "/Default/PortfolioGrowth", //
  PortfolioOverview_URL: baseURL + "/Equity/PortfolioOverview", //
  PayinDetails_URL: baseURL + "/Default/PayInDetails", //
  PayoutDetails_URL: baseURL + "/Default/PayOutDetails", //
};

export const Dashboard_Client_Report = {
  CombineLedgerReport_URL: baseURL + "/Report/CombineLedgerReport", //
  RevenueClientReport_URL: baseURL + "/Report/RevenueClientReport", //
  DividendReport_URL: baseURL + "/Report/DividendReportTrade", //
  DPReport_URL: baseURL + "/Report/DPReportTrade", //
  ClientHoldingReport_URL: baseURL + "/Report/ClientHoldingReport", //
  LedgerReport_URL: baseURL + "/Report/LedgerReport", //
  MorningLimitReport_URL: baseURL + "/Report/MorningLimitReport", //
  GlobalReport_URL: baseURL + "/Report/ConsolidateGlobalReport",//
  MTFDelayPaymentReport_URL: baseURL + "/Report/MTFDelayPaymentReport", //
  MTFDetail_URL: baseURL + "/Report/MTFDetails", //
  PnlReport_URL: baseURL + "/Report/PnlReport", //
  Scripnamedropdown: baseURL + "/Report/scripnamedropdown",
  Expirydatedropdown: baseURL + "/Report/expirydatedropdown",

  TaxReport_URL: baseURL + "/Report/TaxReportTrade", //
  FundTransactionTrade_URL: baseURL + "/Report/FundTransactionTrade", //
  CostReportTrade_URL: baseURL + "/Report/CostReportTrade", //
  Last10TransactionTrade_URL: baseURL + "/Report/Last10TransactionTrade", //
  TradeSummary_URL: baseURL + "/Report/TradeSummaryTrade", //
  LtcgReport_URL: baseURL + "/Report/LtcgReportTrade", //
  LeviesReport_URL: baseURL + "/Report/LeviesReport", //
  GetContractList_URL: baseURL + "/Report/GetContractList", //
  AumClientReport_URL: baseURL + "/Report/AumClientReport", //
  Hierarchy_URL: baseURL + "/Report/HierarchyReport", //
  Single_Holding_URL: baseURL + "/Report/GetScriptName", //
  Script_Wise_Holidng: baseURL + "/Report/V2/ScriptWiseHolidng ", //
  Loan_No_URL: baseURL + "/Report/GetLoanNo", //
  GetSoaDetailURL: baseURL + "/Report/GetSOADetail", //
  GetIVRDetailURL: baseURL + "/Report/GetIVRDetail", //
  // Script_Wise_Holidng: baseURL + "/Report/ScriptWiseHolidng",
  Aging_Report_URL: baseURL + "/Report/AgingReport", //
  TentativeMargin_URL: baseURL + "/Report/GetTentativeMargin", //
  Margin_Report_URL: baseURL + "/Report/GetMarginShortage", //
  IncomeRangeProof_Report_URL: baseURL + "/Report/IncomeRangeProof", //
  IncomeDeclaration_Report_URL: baseURL + "/Report/IncomeDeclaration", //
  IntrestReportTrade_Report_URL: baseURL + "/Report/IntrestReportTrade", //
  Revenue_Report_URL: baseURL + "/Report/ReveneuReportRmtoCos", //
  YieldReport_URL: baseURL + "/Report/YieldReport", //
  PledgeMasterReport_URL: baseURL + "/Report/PledgeHoldingReport", //
  ConsolidatedReport_URL: baseURL + "/Report/ConsolidatedReport",
  Get_VoucherType: baseURL + "/Report/GetLedgerVoucherType",
  Get_ExchangeType: baseURL + "/Report/GetExchangeType",
  Get_ReportType: baseURL + "/Report/GetRportType",
  MtfPos_Report: baseURL + "/Report/MTFPositionReport",
  FnoDeliveryReport_URL: baseURL + "/report/fnodelivery",
  PnlReportScripHistory: baseURL + "/Report/gettradesummarybysegment",
  CMLSendOtp: baseURL + "/cml/sendotp",
  CMLValidateOtp: baseURL + "/cml/validateotp",
  CMLGetDPs:baseURL+"/cml/getdpid",
  AGTS_Report:baseURL+"/Report/agtsreport",
  STT_Report:baseURL+"/Report/sttreport",
  Update_Itr_Report: baseURL + "/Report/updateitrreport",
  Get_Itr_Report: baseURL + "/Report/getitrreport",
  Download_Itr_Report: baseURL + "/Report/getitrfilesdownload",
  Itemised_Margin_Report: baseURL + "/Report/ItemizedMarginReport",
  Advanced_Tax_Report: baseURL + "/report/AdvanceTaxReport",
  SurchargeMaster: baseURL + "/report/SurchargeMaster",
  Health_Education_Master: baseURL + "/report/HealthAndEducationCessMaster",
  Tax_Report_Excel: baseURL + "/report/AdvanceTaxExcel",
  Get_DP_Name: baseURL + "/Report/getDPName",
};

export const Client_Search = {
  // Search_URL: baseURL + "/Default/ClientSearch",
  Search_URL: baseURL + "/Default/ClientSearchPagination", //
};

export const Scrip_Search = {
  Scrip_Search_URL: baseURL + "/Report/GetScripName",
}

export const Login_Page = {
  Login_URL: baseURL + "/Default/LoginNew", //
  Forget_UserName_URL: baseURL + "/Default/ForgotUsername", //
  Forgot_Password: baseURL + "/Default/ForgotPassword", //
  Forgot_PasswordV3: baseURL + "/Default/V3/ForgetPassword", //
  Forgot_ChangePasswordV2: baseURL + "/Default/V2/ChangePassword", //
  Change_Password: baseURL + "/Default/ResetPassword", //
};

export const Header = {
  Logout_URL: baseURL + "/Default/Logout", //
};

export const Onboarding_Page = {
  OnbOarding_URL_NEW: baseURL + "/Default/V3/OnBoardingWithStatusType", //
  RejectedOnboarding_URL: baseURL + "/Default/RejectionOnBoardingData",
  PendingOnboarding_URL: baseURL + "/Default/PendingOnBoardingData",
  EditDocument_URL: baseURL + "/Default/EditApplication",
  OnboardingFilter_URL: baseURL + "/Default/FilterSearch", //
  OnboardingSaveFilterSearch_URL: baseURL + "/Default/SaveFilterSearch", //
  OnboardingGetFilterSearch_URL: baseURL + "/Default/GetFilterSearch", //
  OnboardingResetFilter_URL: baseURL + "/Default/ResetFilterSearch", //
};

export const Help_Guide = {
  Client_Support_URL: baseURL + "/Default/ClientSupport", //
};

export const Get_Details = {
  Get_Ticket_Details_URL:
    Samadhan_Base_Url + "/GetClientDetails/GetClientTickets", //
  Get_Ticket_Coversation:
    Samadhan_Base_Url + "/GetClientDetails/GetTicketConversation", //
};
// export const LoginInfo_Active_Inactive = {
//   Get_Login_Info_URL: Msil_Base_Url + "/user/LoginUserInfo/1.0.0", //
// };
export const Contact_Us = {
  Contact_Us_URL: baseURL + "/Default/ContactUsDetails", //
};

export const Rm_Ap_Mapping = {
  //Ap RM

  Get_AP_Code_URL: baseURL + "/Report/GetAPCode", //
  Get_Branch_Name_URL: baseURL + "/Report/GetBranch", //
  Get_Branch_Name_URL: baseURL + "/Report/GetBranch", //
  Save_Rm_Code_Ap_Name_URL: `${baseURL}/Report/SaveRmCodeApName`, //
  RM_AP_Mapping_Report_URL: `${baseURL}/Report/RMAPMappingReport`, //
  Update_RM_URL: `${baseURL}/Report/UpdateRM`, //
  //client RM
  Get_Client_Code_URL: `${baseURL}/Report/GetClientCode`, //
  RM_Client_Mapping_Report_URL: `${baseURL}/Report/RMClientMappingReport`, //
  Get_RM_Name_URL: `${baseURL}/Report/GetRMName`, //
  Update_Client_RM_URL: `${baseURL}/Report/UpdateClientRM`, //
  Save_Client_Rm_Code_Name_URL: `${baseURL}/Report/SaveClientRmCodeName`, //
};
export const AP_Master = {
  Get_Ap_Codes_URL: baseURL + "/AutoPayout/GetAPCodes", //
  Get_ClientAp_Code_URL: baseURL + "/AutoPayout/GetClientAPCodes", //
  Get_Ap_Master_URL: baseURL + "/AutoPayout/displaybrokerage", //
  GetClientMaster_URL: baseURL + "/AutoPayout/GetClientMaster", //
  BrokerageWiseModules_URL: baseURL + "/AutoPayout/BrokerageWiseModules", //
  Submit_ApMaster_URL: baseURL + "/AutoPayout/UpdateBrokerage", //
  Submit_ClientMaster_URL: baseURL + "/AutoPayout/UpdateBrokerageToClient", //
  Get_Master_Codes_URL: baseURL + "/AutoPayout/GetMasterAPCodes", //
  BrokerageWiseModulesForClient_URL:
    baseURL + "/AutoPayout/BrokerageWiseModulesForClient", //
  GetClientCodes_URL: baseURL + "/AutoPayout/GetClientCodes",
  UploadOnAwsFile_URL: baseURL + "/AutoPayout/uploadfileonaws", //
  UpdateRemark_URL: baseURL + "/AutoPayout/UpdateRemarks",
  BankNames_URL: baseURL + "/AutoPayout/banknames",
  BranchLocation_URL: baseURL + "/AutoPayout/branchloc",
  GetIfsc_URL: baseURL + "/AutoPayout/ifsc",
  ImpsBankVerify_URL: baseURL + "/AutoPayout/impsbankverification",
  GetBankNameByIfsc_URL: baseURL + "/AutoPayout/banknamebyifsc",
  GetBrokerageSlab_URL: baseURL + "/AutoPayout/getbrokerageslabformodule4",
  GetApSharing_URL: baseURL + "/AutoPayout/getapsharingformodule4"
};

export const AP_Payout_Rms = {
  GetMasterAPList_URL: baseURL + "/AutoPayout/getpayoutforfranchiseeteam", //
  GetClientRawData_URL: baseURL + "/AutoPayout/GetClientsRawData", //
  InsertPayoutDetails_URL: baseURL + "/AutoPayout/updatepayoutbyfranchiseeteam", //
  RmsDataList_URL: baseURL + "/AutoPayout/getpayoutforrmsteam", //
  RmsInsertUpdate_URL: baseURL + "/AutoPayout/updatepayoutbyrmsteam", //
};



export const Account_Rights = {
  GetAccountRightsData_URL: baseURL + "/AutoPayout/getpayoutforfinanceteam", //
  InsertAccountRightsData_URL: baseURL + "/AutoPayout/updatepayoutbyfinanceteam", //
};

export const AP_Payout_Banking = {
  GetBankingDetails_URL: baseURL + "/AutoPayout/getpayoutforbankingteam", //
  InsertBankingDetails_URL: baseURL + "/AutoPayout/updatepayoutbybankingteam", //
};

export const IPO_Master = {
  GetMasterIpoData_URL: baseURL + "/AutoPayout/MasterDataDownload", //
  UploadIpoMaster_URL: baseURL + "/AutoPayout/UploadIpoMasterData", //
};

export const Freeze_Unfreeze = {
  sendOtp_URL: baseURL + "/FreezeUnfreeze/SendOTP",
  validateOtp_URL: baseURL + "/FreezeUnfreeze/ValidateOTP",
  SkipAuthentication: baseURL + "/FreezeUnfreeze/SkipAuthentication",
  SkipAuthenticationProceed:
    baseURL + "/FreezeUnfreeze/SkipAuthenticationProceed",
  UpdateFreezUnfreezStatus:
    baseURL + "/FreezeUnfreeze/UpdateFreezUnfreezStatus",
};

export const Hni_Admin_Api = {
  gethnipackdetails: hniBaseUrl + "/gethnipackdetails",
  inserthnipackdetail: hniBaseUrl + "/inserthnipackdetail",
  listofhnipackdetail: hniBaseUrl + "/listofhnipackdetail",
  deactivatehnipackdetail: hniBaseUrl + "/deactivatehnipackdetail",
  generatesocialmedialink: hniBaseUrl + "/generatesocialmedialink",
  getPersonalisedDetail: hniBaseUrl + "/personaliseddetail",
  insertPersonalDetail: hniBaseUrl + "/insertpersonaliseddetail",
  getDpcList: hniBaseUrl + "/dpc",
  getMtfList: hniBaseUrl + "/mtf",
  uploadDocOnAwsFile: hniBaseUrl + "/uploadfileonaws",
  updateDetails: hniBaseUrl + "/updatepersonaliseddetail",
  updateRemarks: hniBaseUrl + "/updateremarksforpersonaliseddetail",
  generateLink: hniBaseUrl + "/personalisedlink",
  getGeneralDetail: hniBaseUrl + "/generaldetail",
  insertGeneralDetail: hniBaseUrl + "/insertgeneraldetail",
  getPackDetails: hniBaseUrl + "/getgeneralhnipackdetails",
  updateGeneralDetails: hniBaseUrl + "/updategeneraldetail",
  generateGeneralLink: hniBaseUrl + "/generallink",
  updateGeneralRemarks: hniBaseUrl + "/updateremarksforgeneraldetail",
  getAmcList: hniBaseUrl + "/amc",
  gethniekyclink:baseURL+"/HNI/gethniekyclink",
}

export const CLIENT_FNO = {
  Get_Client_FnO: baseURL + "/fnoloss/clientsfnoloss",
  Update_Document: baseURL + "/fnoloss/uploadledgerdoc",
  Download_Doc: baseURL + "/fnoloss/downlodledgerdoc",
  getfnolossyear:baseURL+"/fnoloss/getfnolossyear"
}
export const Hierarchy = {
  Insert_Business_Data: baseURL + "/Hierarchy/businessheaddetails",
  Get_Business_Data: baseURL + "/Hierarchy/getbusinessheaddetails",
  Get_NationalHead_Data: baseURL + "/Hierarchy/getnationalheaddetails",
  Insert_NationalHead_Data: baseURL + "/Hierarchy/nationalheaddetails",
  Search_Business_Head: baseURL + "/Hierarchy/businessheaddropdown",
  Get_Zonal_Data: baseURL + "/Hierarchy/getzonalmaster",
  Insert_Zonal_Data: baseURL + "/Hierarchy/zonalmaster",
  Search_National_Head: baseURL + "/Hierarchy/nationalheaddropdown",
  Get_Regional_Data: baseURL + "/Hierarchy/getregionmaster",
  Insert_Regional_Data: baseURL + "/Hierarchy/regionmaster",
  Search_Zonal_Head: baseURL + "/Hierarchy/zonalcodedropdown",
  Get_Branch_Data: baseURL + "/Hierarchy/getbranchmaster",
  Insert_Branch_Data: baseURL + "/Hierarchy/branchmaster",
  Search_Region_Head: baseURL + "/Hierarchy/regioncodedropdown",
  Get_BranchCode: baseURL + "/hierarchy/getbranchcodes"
}
export const MutualFund = {
  Mandate: baseURL + "/MutualFund/orderdetails",
  Digiomandate: baseURL + "/MutualFund/digiomandate",
  Siptransdigio: baseURL + "/MutualFund/siptransdigio",
  Recurringdashboard: baseURL + "/MutualFund/recurringdashboard",
  Bsereconciliation: baseURL + "/MutualFund/bsereconciliation",
};
export const MtfPMR = {
  mtfpmr: baseURL + "/report/mtfpmr",
};

export const MFReports = {
  ELSS: baseURL + "/MutualFund/elssstatement",
  Capital_Gain: baseURL + "/MutualFund/capitalgain",
  Fund_Holding: baseURL + "/MutualFund/fundholding",
  Transaction_History: baseURL + "/MutualFund/transactionhistory",
};

export const Lead_Creation = {
  Send_Mobile_OTP: baseURL + "/hni/sendsmsotp",
  Validate_Mobile_Otp: baseURL + "/hni/validatesmsotp",
  Send_Mail_OTP: baseURL + "/hni/sendemailotp",
  Validate_Mail_OTP: baseURL + "/hni/validateemailotp",
  Select_Relation: baseURL + "/hni/getmasterdetails",
  Save_Relation: baseURL + "/hni/saverelation",
  Resume_journey: baseURL + "/hni/resume",
  Basic_Details: baseURL + "/hni/insertbasicdetails",
  Pan_Validate: baseURL + "/hni/validatepan",
  Personal_Details: baseURL + "/hni/insertpersonaldetails",
  pincode_Details: baseURL + "/hni/getcityandstatebypincode",
  nominee_Details: baseURL + "/hni/insertnomineedetails",
  bank_Details: baseURL + "/hni/insertbankdetails",
  delete_Nominee: baseURL + "/hni/deletenomineedetail",
  imps_verification: baseURL + "/hni/impsbankverification",
  brokerage_Details: baseURL + "/hni/insertbrokeragedetails",
  segment_Activation: baseURL + "/hni/segmentactivation",
  Leade_Create: baseURL + "/hni/leadcapture",
  Overview_Individual: baseURL + "/hni/individualaccountoverview",
  GetOver_Individual_Data: baseURL + "/hni/getoverviewdetails",
  Delete_Overview_List: baseURL + "/hni/deleteapplication",
  view_Lead_Table: baseURL + "/hni/downloadaof",
  Final_Status: baseURL + "/hni/finalsubmission",
};

export const Stock_Analytics = {
  Stock_Analytics_Details: baseURL + "/Default/StockAnalyticsNewDetails",
};

export const IPO_Document = {
  Get_IPO_Category: baseURL + "/IPO/getipocategory",
  Get_Investor_Status: baseURL + "/IPO/getipoinvestorstatus",
  Get_IPOName_SBCode: baseURL + "/IPO/getiponamesbcode",
  Fetch_IPO_Details: baseURL + "/IPO/fetchipodetails",
  Save_IPO_Document: baseURL + "/IPO/saveipodocument",
  Get_IPODoc_Grid: baseURL + "/IPO/ipodocgrid",
  Generate_IPODocument: baseURL + "/IPO/generateipodoc",
  Download_IPODocument: baseURL + "/IPO/downloadipodoc",
  BankDetailsForIPO: baseURL + "/IPO/bankdetailsforipo",
};


export const Partner_Payout_Rms = {
  GetMasterAPList_URL: baseURL + "/partner/getpartnerpayout", //
  InsertPayoutDetails_URL: baseURL + "/partner/updatepartnerpayout", //
  GetPartnerRawData_URL: baseURL + "/partner/getpartnerrawdata", //

};

export const APLadger = {
  // Search_URL: baseURL + "/Default/ClientSearch",
  uploadAPLadger: baseURL + "/Report/uploadAPLadger", //
  getAPLadgerDashboard: baseURL + "/Report/getAPLadgerReport", //
  GetAPLadgerBalanceDetails: baseURL + "/Report/getAPLadgerBalanceDetails", //
  GetAPList: baseURL + "/Report/getAPList", //

};

export const IBA_Admin_Section ={
  overviewCards: esopBaseURL + "/iba/api/v1/admin/DashboardCount",
  adminOverviewGraph: esopBaseURL + "/iba/api/v1/admin/FetchGraphDetail",
  adminDownloadFile: esopBaseURL + "/iba/api/v1/admin/DownloadFile",
  getAgentDetails: esopBaseURL + "/iba/api/v1/admin/AgentDetails",
  agentPersonalDetails: esopBaseURL + "/iba/api/v1/agent/PersnalAgentDetails",
  deactivateAgent: esopBaseURL + "/iba/api/v1/agent/DeactivationAgent",
  updateProfile: esopBaseURL + "/iba/api/v1/agent/UpdatePersnalAgentDetails",
  getTeamLeaderData: esopBaseURL + "/iba/api/v1/admin/TeamLeaderList",
  agentPerformanceData: esopBaseURL + "/iba/api/v1/admin/AgentPerformance",
  agentPayoutList: esopBaseURL + "/iba/api/v1/payout/MonthlyPayoutData",
  agentPayoutListDownload: esopBaseURL + "/iba/api/v1/download/DownloadPayoutData",
  approvePayoutData: esopBaseURL + "/iba/api/v1/payout/SaveMonthlyPayout",
  holdAgentData: esopBaseURL + "/iba/api/v1/payout/MonthlyHoldPayoutData",
  RevenueEarnedGraph: esopBaseURL + "/iba/api/v1/agent/RevenueEarnedCountByDate",
  AccountsOpenedGraph: esopBaseURL + "/iba/api/v1/agent/AccountOpenCountByDate",
  Feedback_Input: esopBaseURL + "/iba/api/v1/admin/SubmitFeedback",
  Agent_Overview_Dashboard: esopBaseURL + "/iba/api/v1/agent/AgentOverviewDashboard",
}

export const MutualFunds_Section = {
  mfSnapshot: MutualFundsProdURL + "/Reports/v4/holdings",
}

export const TELECALLER_ID_UPDATION_SECTION = {
  clientDetailsByRefNumber: "/api/ekycadmin/updation/get-clientdetailsbyrefno",
  userIDs: "/api/ekycadmin/updation/userids",
  telecallerIDUpdate: "/api/ekycadmin/updation/update-userid",
  telecallerIDUnmap: "/api/ekycadmin/updation/unmap-userid",
};